import CommonWsLayoutHeader from "pages/commons/component/layout/CommonWsLayoutHeader";
import { Outlet } from "react-router-dom";
import { useRecoilState } from "recoil";
import { NavbarState } from "stores/atoms/navbarState";
import WsLayoutNavbar from "./WsLayoutNavbar";

/**
 *　設定画面のレイアウト定義
 */
export default function WsLayout(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const [navbarState, setNavbarState] = useRecoilState(NavbarState);

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   *　スマートフォンレイアウト時のナビゲーションバーを閉じます
   */
  const onSpNavbarClose = () => {
    if (navbarState.open) {
      setNavbarState({ open: false });
    }
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <main>
      <CommonWsLayoutHeader />
      <WsLayoutNavbar />
      <div
        onClick={onSpNavbarClose}
        className={`col-main ${navbarState.open ? "body-with-overlay" : ""}`}
      >
        <Outlet />
      </div>
    </main>
  );
}
